/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_Trained_For_6mto2yInputs */

const en_us2_onboarding_experience_trained_for_6mto2y = /** @type {(inputs: Onboarding_Experience_Trained_For_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 months to 2 years`)
};

const pt_br2_onboarding_experience_trained_for_6mto2y = /** @type {(inputs: Onboarding_Experience_Trained_For_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 6 meses a 2 anos`)
};

const es_419_onboarding_experience_trained_for_6mto2y = /** @type {(inputs: Onboarding_Experience_Trained_For_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 6 meses a 2 años`)
};

const pt_pt2_onboarding_experience_trained_for_6mto2y = /** @type {(inputs: Onboarding_Experience_Trained_For_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 6 meses a 2 anos`)
};

const fr_fr2_onboarding_experience_trained_for_6mto2y = /** @type {(inputs: Onboarding_Experience_Trained_For_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 mois à 2 ans`)
};

const de_de2_onboarding_experience_trained_for_6mto2y = /** @type {(inputs: Onboarding_Experience_Trained_For_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 Monate bis 2 Jahre`)
};

const it_it2_onboarding_experience_trained_for_6mto2y = /** @type {(inputs: Onboarding_Experience_Trained_For_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 6 mesi a 2 anni`)
};

/**
* | output |
* | --- |
* | "6 months to 2 years" |
*
* @param {Onboarding_Experience_Trained_For_6mto2yInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_trained_for_6mto2y = /** @type {((inputs?: Onboarding_Experience_Trained_For_6mto2yInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_Trained_For_6mto2yInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_trained_for_6mto2y(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_trained_for_6mto2y(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_trained_for_6mto2y(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_trained_for_6mto2y(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_trained_for_6mto2y(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_trained_for_6mto2y(inputs)
	return en_us2_onboarding_experience_trained_for_6mto2y(inputs)
});
export { onboarding_experience_trained_for_6mto2y as "onboarding.experience_trained_for.6mto2y" }